export default __webpack_public_path__ + "static/media/devBgSub.fd27c857.png";